import React, { Fragment, useEffect, useState } from 'react'
import Driverheader from './Driverheader'
import { Button, CardContent, CircularProgress, Divider, Grid, Modal, Typography } from '@mui/material'
import { Card } from 'react-bootstrap'
import axios from '../Components/axiosInstance';
import { Apiurl } from '../api_urls'
import { GToaster, customshiftvalue, getcustomdate, getcustomformatdate } from '../Components/g_toaster'
import { useDispatch, useSelector } from 'react-redux'
import { Add, DoNotTouch, Forward } from '@mui/icons-material'
import GooglePlaces from '../Components/GooglePlaces'
import Termagree from '../Components/Termagree'
import Gmodal from '../Components/Gmodal'
import { getoldshiftdata } from '../redux_store/Shiftavailabilty'
import Downloadapp from '../Components/Downloadapp'

const toster = new GToaster()
const DriverShiftAvailablity = () => {
    const dispatch = useDispatch()
    const rideruser = useSelector((state) => state?.data?.riderdata?.rider)
    const oldshiftdata = useSelector((state) => state?.data?.ridershiftdata?.oldshiftdata)
    const [shiftdata, setshiftdata] = useState([])
    const [btnloader, setbtnloader] = useState(false)
    const [isloading, setisloading] = useState(false)
    const [isdownloadapp, setisdownloadapp] = useState(true)
    const [morningtimes, setmorningtimes] = useState([])
    const [noontimes, setnoontimes] = useState([])
    const [eveningtimes, seteveningtimes] = useState([])
    const [nighttimes, setnighttimes] = useState([])
    const [editaddress, seteditaddress] = useState(false)
    const [factoryaddress, setfactoryaddress] = useState("")
    const [alladdress, setalladdress] = useState([])
    const [isagree, setisagree] = useState(false)
    const [reconfirm, setreconfirm] = useState(false)
    const [timecut, settimecut] = useState("")
    const [mymodaldata, setmymodaldata] = useState({
        modalshow: false,
        modaltype: "success",
        modalmessage: "raju"
    })
    const [openModal, setOpenModal] = useState(false)
    let regulardata = [
        {
            "shift_type": "Morning",
            "going_time": "",
            "return_time": ""
        },
        {
            "shift_type": "Afternoon",
            "going_time": "",
            "return_time": ""
        },
        {
            "shift_type": "Evening",
            "going_time": "",
            "return_time": ""
        },
        {
            "shift_type": "Night",
            "going_time": "",
            "return_time": ""
        }
    ]

    function closemodal(e) {
        mymodaldata["modalshow"] = e
        mymodaldata["modalmessage"] = ""
        mymodaldata["modaltype"] = ""
        setmymodaldata({ ...mymodaldata })
    }

    async function getrideraddress() {
        await axios.get(`${Apiurl.GET_PARTICULAR_DRIVER_ADDRESSES_URL}${rideruser.id}`).then((res) => {
            if (res.data.status === 200) {
                let newdata = res.data.addresses
                let founddata = newdata.find((ele) => ele?.factory === "yes" && ele?.type === "primary")
                if (founddata) {
                    setfactoryaddress({ ...founddata })
                }

                setalladdress([...newdata])

            }
        }).catch((err) => {
            toster.error({ title: "Something Went Wrong in Pickup Addresses fetch" })
        })
    }

    function gopicadress(e, zip, city, label, lat, long) {
        let myobj = {
            ['id']: 0, ["address"]: label, ["tag"]: "factory", ["postal_code"]: zip, ["city"]: city, ['type']: "primary", ["factory"]: "yes", ["user_id"]: rideruser.id,
            ["lat"]: lat,
            ["long"]: long,
        }
        setfactoryaddress({ ...myobj });

    }

    async function Mydate() {
        setisloading(true)
        await axios.get(`${Apiurl.GET_BOOKING_DAYS_URL}`).then(async (succ) => {
            if (succ.status === 200) {
                let response = succ.data.days
                let data = [...response]

                let selectdata = data.map((ele, index) => {
                    return {
                        ["date"]: ele?.label, ["data"]: [...regulardata], ["mydate"]: ele?.value, ["reversedate"]: getcustomformatdate(ele?.value)
                    }
                })

                await riderallshift([...selectdata])
                setisloading(false)
            }
        }).catch((err) => {
            setisloading(false)
            toster.error({ title: "Something Went worng in fetching dates from Admin" })
        })
    }

    async function getridertimedata(shift) {
        await axios.get(`${Apiurl.RIDER_ALL_SHIFT_TIME}${shift}`).then((response) => {
            if (response.data.status == 200) {
                let extravalue = [{ ["label"]: "Not Available", ["value"]: "" }, { ["label"]: "All", ["value"]: "All" }]

                let responsedata = response.data.data.map((ele) => {
                    return {
                        ["label"]: ele, ["value"]: ele
                    }
                })
                let newdata = [...extravalue, ...responsedata]

                if (shift === "morning") {
                    setmorningtimes(newdata)
                }
                if (shift === "afternoon") {
                    setnoontimes(newdata)
                }
                if (shift === "evening") {
                    seteveningtimes(newdata)
                }
                if (shift === "night") {
                    setnighttimes(newdata)
                }
                return newdata
            } else {
                toster.error({ title: "Something is worng in fetching rider timings" })
            }
        }).catch((err) => {
            toster.error({ title: "Something is worng in fetching rider timings" })
        })
    }


    const handlechange = (key, value, index, innerindex) => {
        let newdata = JSON.parse(JSON.stringify(shiftdata))
        newdata[index]["data"][innerindex][key] = value
        setshiftdata([...newdata])
    }

    const riderallshift = async (data) => {
        await axios.get(`${Apiurl.GET_RIDER_SHIFT_DATA_URL}${rideruser?.id}`).then((response) => {
            if (response.status === 200) {
                if (response.data?.status == 200) {
                    let newdata = response.data.data
                    if (newdata.length > 0) {
                        getingdata(newdata, data)
                    }
                } else {
                    toster.error({ title: "something went wrong please reload your page again" });
                }
            } else {
                toster.error({ title: "something went wrong please reload your page again" });
            }
        }).catch((Err) => {
            toster.error({ title: "something went wrong please reload your page again" });
        })
    }


    const getingdata = (responsedata, shiftdatedata) => {
        let newdata = JSON.parse(JSON.stringify(shiftdatedata))
        for (let index = 0; index < newdata.length; index++) {
            let datedata = newdata[index]?.mydate
            let founddata = responsedata.find((ele) => ele?.shift_date === datedata)
            if (!!founddata) {
                const goingSlot = founddata?.going_slot
    ? JSON.parse(founddata.going_slot)
    : {};

const returnSlot = founddata?.return_slot
    ? JSON.parse(founddata.return_slot)
    : {};

let makearraydata = [
    {
        shift_type: "Morning",
        going_time: goingSlot?.Morning || "",
        return_time: returnSlot?.Morning || "",
    },
    {
        shift_type: "Afternoon",
        going_time: goingSlot?.Afternoon || "",
        return_time: returnSlot?.Afternoon || "",
    },
    {
        shift_type: "Evening",
        going_time: goingSlot?.Evening || "",
        return_time: returnSlot?.Evening || "",
    },
    {
        shift_type: "Night",
        going_time: goingSlot?.Night || "",
        return_time: returnSlot?.Night || "",
    }
];
                newdata[index]["data"] = [...makearraydata]
            }

        }
        setshiftdata([...newdata])
        dispatch(getoldshiftdata([...newdata]))
    }

    const getshiftcutdata = async () => {
        let data = ""
        await axios.get(Apiurl.GET_BOOKING_TIMECUT_URL).then((res) => {
            if (res.status === 200) {
                if (res.data?.status === 200) {
                    let timecutdata = res.data.data
                    settimecut(timecutdata)
                    data = res.data.data
                }
            } else {
                toster.error({ title: "something went wrong in fetching timecut" });
            }
        })
        return data
    }

    const checkbooking = async () => {
        const shiftvalue = customshiftvalue()
        const datevalue = getcustomdate()
        let timecutdata = await getshiftcutdata()
        let booleandata = ""
        if ((datevalue === timecutdata?.datecut && timecutdata?.morning_status === 1 && shiftvalue === "morning")
            || (datevalue === timecutdata?.datecut && timecutdata?.afternoon_status === 1 && shiftvalue === "afternoon")
            || (datevalue === timecutdata?.datecut && timecutdata?.evening_status === 1 && shiftvalue === "evening")
            || (datevalue === timecutdata?.datecut && timecutdata?.night_status === 1 && shiftvalue === "night")) {
            booleandata = true
        } else {
            booleandata = false
        }
        return booleandata
    }

    const newcheckbooking = async () => {
        let timecutdata = await getshiftcutdata()
        let shift = Object.entries(timecutdata)
        let allshiftdata = shift.filter((ele) => ele[1] === 1 && ele[0].length > 3).map((ele) => {
            let change = ele[0].split("_")
            return change[0]
        })
        let booolval = ""
        let oldfounddata = oldshiftdata.find((ele) => ele?.reversedate === timecutdata?.datecut)
        let newfounddata = shiftdata.find((ele) => ele?.reversedate === timecutdata?.datecut)
        for (let index = 0; index < allshiftdata.length; index++) {
            const shiftelement = allshiftdata[index];
            let oldinnerfounddata = oldfounddata?.data?.find((ele) => ele?.shift_type?.toLowerCase() === shiftelement)
            let newinnerfounddata = newfounddata?.data?.find((ele) => ele?.shift_type?.toLowerCase() === shiftelement)

            if (!(oldinnerfounddata?.going_time === newinnerfounddata?.going_time) || !(oldinnerfounddata?.return_time === newinnerfounddata?.return_time)) {
                booolval = { ["errorval"]: true, ["date"]: timecutdata?.datecut, ["shift"]: shiftelement }
            } else {
                booolval = false
            }
        }

        return booolval
    }


    const Addshift = async () => {
        let errormsg = await newcheckbooking()
        if (errormsg?.errorval) {
            mymodaldata["modalshow"] = true;
            mymodaldata["modaltype"] = "error";
            mymodaldata["modalmessage"] = `Schedule is already lapsed for ${errormsg?.date} (${errormsg?.shift})`
            setmymodaldata({ ...mymodaldata })
        } else {
            setbtnloader(true)

            let address = {
                "addresses": factoryaddress
            }
            if (!!factoryaddress?.address) {
                await axios.post(`${Apiurl.ADD_FACTORY_ADDRESS_URL}`, address).then((response) => {
                    if (response.status === 200) {
                        getrideraddress()
                        seteditaddress(false);
                    }
                }).catch((Err) => {
                    toster.error({ title: "something went wrong please reload your page again" });
                })
            }
    const payload = shiftdata.map((item) => {
    const morning = item.data.find(x => x.shift_type === "Morning") || {};
    const afternoon = item.data.find(x => x.shift_type === "Afternoon") || {};
    const evening = item.data.find(x => x.shift_type === "Evening") || {};
    const night = item.data.find(x => x.shift_type === "Night") || {};

    return {
        date: item.date,
        going_slot: {
            Morning: morning.going_time || "",
            Afternoon: afternoon.going_time || "",
            Evening: evening.going_time || "",
            Night: night.going_time || ""
        },
        return_slot: {
            Morning: morning.return_time || "",
            Afternoon: afternoon.return_time || "",
            Evening: evening.return_time || "",
            Night: night.return_time || ""
        }
    };
});

            await axios.post(`${Apiurl.ADD_RIDER_SHIFT_DATA_URL}${rideruser?.id}`, payload).then(async (response) => {
                if (response.status === 200) {
                    setbtnloader(false)
                    await Mydate()
                    setreconfirm(false)
                    setOpenModal(false)
                } else {
                    setbtnloader(false)
                    toster.error({ title: "something went wrong please reload your page again" });
                }
            }).catch((Err) => {
                setbtnloader(false)
                toster.error({ title: "something went wrong please reload your page again" });
            })
        }
    }

    const getkeysdata = (obj) => {
        if (obj === "Morning") {
            return morningtimes
        } else if (obj === "Afternoon") {
            return noontimes
        } else if (obj === "Evening") {
            return eveningtimes
        } else {
            return nighttimes
        }
    }

    function changeagreestate(e) {
        setisagree(e)
    }

    async function changestatus() {
        let errormsg = await newcheckbooking()
        if (errormsg?.errorval) {
            mymodaldata["modalshow"] = true;
            mymodaldata["modaltype"] = "error";
            mymodaldata["modalmessage"] = `Schedule is already lapsed for ${errormsg?.date} (${errormsg?.shift})`
            setmymodaldata({ ...mymodaldata })
        } else {
            setreconfirm(true)
            setOpenModal(true)
        }
    }

    function disabledoption(timecutdata, shift_type, reverse_Date) {
        if (((reverse_Date === timecutdata?.datecut && timecutdata?.morning_status === 1 && shift_type === "Morning")
            || (reverse_Date === timecutdata?.datecut && timecutdata?.afternoon_status === 1 && shift_type === "Afternoon")
            || (reverse_Date === timecutdata?.datecut && timecutdata?.evening_status === 1 && shift_type === "Evening")
            || (reverse_Date === timecutdata?.datecut && timecutdata?.night_status === 1 && shift_type === "Night"))) {
            return true
        } else {
            return false
        }
    }

    async function checkdata(shift_type, reverse_Date) {
        let timecutdata = await getshiftcutdata()
        if (((reverse_Date === timecutdata?.datecut && timecutdata?.morning_status === 1 && shift_type === "Morning")
            || (reverse_Date === timecutdata?.datecut && timecutdata?.afternoon_status === 1 && shift_type === "Afternoon")
            || (reverse_Date === timecutdata?.datecut && timecutdata?.evening_status === 1 && shift_type === "Evening")
            || (reverse_Date === timecutdata?.datecut && timecutdata?.night_status === 1 && shift_type === "Night"))) {
            mymodaldata["modalshow"] = true;
            mymodaldata["modaltype"] = "error";
            mymodaldata["modalmessage"] = `Schedule is Already Lapsed For  ${reverse_Date} (${shift_type})`
            setmymodaldata({ ...mymodaldata })
        }
    }


    function closedownload(e) {
        setisdownloadapp(e)
    }

    const sliceDate = (date)=>{
        let newdate = date?.split("-")
        return `${newdate[newdate?.length - 1]?.slice(1,3)}-${newdate[0]}` 
    }

    useEffect(() => {
        Mydate()
        getridertimedata("morning")
        getridertimedata("afternoon")
        getridertimedata("evening")
        getridertimedata("night")
        getrideraddress()
        getshiftcutdata()
    }, [])

    return (<>
        <Driverheader />
        {mymodaldata.modalshow == true && <Gmodal closemodal={closemodal} handledata={mymodaldata} />}
        {isdownloadapp ? <>
            <Downloadapp isdownload={isdownloadapp} closedownload={closedownload} usertype={"rider"} />
        </> : <>
            {isagree ? <>
                <Grid container spacing={2}>
                    <Grid item lg={8} md={10} sm={10} xs={12} sx={{ m: "auto", mt: 3 }}>
                        <Card>
                            <CardContent>
                                {isloading ? <center><CircularProgress /></center> :
                                    <Fragment>

                                        <Grid container sx={reconfirm ? { cursor: "not-allowed", pointerEvents: "none" } : {}} spacing={window.innerWidth < 1024 ? 2 : 4}>
                                            

                                            {shiftdata.map((obj, index) => (
                                                <Fragment key={index}>
                                                    <Grid xs={12} sx={{ background: "#117fb7", ml: window.innerWidth < 1024 ? 2 : 4, p: 1, mt: 2 }}>
                                                        <Typography variant='h6' sx={{ textTransform: "capitalize", color: "white" }}>
                                                            {obj?.date.split(" - ")[0]} {obj?.date.split(" - ")[1]}
                                                        </Typography>
                                                    </Grid>

                                                    {window.innerWidth < 1024 ? <>

                                                        {obj?.data?.map((ele, innerindex) => (
                                                            <Fragment key={innerindex}>
                                                                <Grid item lg={3} md={3} sm={6} xs={6} >
                                                                    <label >Going {ele?.shift_type}</label>
                                                                    <select onClick={() => checkdata(ele?.shift_type, obj?.reversedate)} className="form-select form-control form-select-lg"
                                                                        name="going_time" value={ele?.going_time ?? ""} onChange={(e) => handlechange(e.target.name, e.target.value, index, innerindex)} >
                                                                        {getkeysdata(ele?.shift_type)?.map((elm, index) => (
                                                                            <option disabled={disabledoption(timecut, ele?.shift_type, obj?.reversedate)} key={index} value={elm?.value}>{elm?.label}</option>
                                                                        ))}
                                                                    </select>
                                                                </Grid>

                                                                <Grid item lg={3} md={3} sm={6} xs={6}    >
                                                                    <label >Return {ele?.shift_type}</label>
                                                                    <select onClick={() => checkdata(ele?.shift_type, obj?.reversedate)} className="form-select form-control form-select-lg" name="return_time" value={ele?.return_time ?? ""} onChange={(e) => handlechange(e.target.name, e.target.value, index, innerindex)} >
                                                                        <option value={""}>Not Available </option>
                                                                        {getkeysdata(ele?.shift_type)?.map((elm, index) => (
                                                                            <option disabled={disabledoption(timecut, ele?.shift_type, obj?.reversedate)} key={index} value={elm?.value}>{elm?.label}</option>
                                                                        ))}
                                                                    </select>

                                                                </Grid>

                                                            </Fragment>
                                                        ))}

                                                    </> : <>

                                                        {obj?.data?.map((ele, innerindex) => (
                                                            <Fragment key={innerindex}>
                                                                <Grid item lg={3} md={3} sm={6} xs={12} >
                                                                    <label className="form-label">Going {ele?.shift_type}</label>
                                                                    <select
                                                                        onClick={() => checkdata(ele?.shift_type, obj?.reversedate)}
                                                                        className="form-select form-control form-select-lg" name="going_time" value={ele?.going_time ?? ""} onChange={(e) => handlechange(e.target.name, e.target.value, index, innerindex)} >
                                                                        {getkeysdata(ele?.shift_type)?.map((elm, index) => (
                                                                            <option disabled={disabledoption(timecut, ele?.shift_type, obj?.reversedate)} key={index} value={elm?.value}>{elm?.label}</option>
                                                                        ))}


                                                                    </select>
                                                                </Grid>
                                                            </Fragment>
                                                        ))}

                                                        {obj?.data?.map((ele, innerindex) => (
                                                            <Fragment key={innerindex}>
                                                                <Grid item lg={3} md={3} sm={6} xs={12}    >
                                                                    <label className="form-label">Return {ele?.shift_type}</label>
                                                                    <select
                                                                        onClick={() => checkdata(ele?.shift_type, obj?.reversedate)}
                                                                        className="form-select form-control form-select-lg" name="return_time" value={ele?.return_time ?? ""} onChange={(e) => handlechange(e.target.name, e.target.value, index, innerindex)} >
                                                                        {getkeysdata(ele?.shift_type)?.map((elm, index) => (
                                                                            <option disabled={disabledoption(timecut, ele?.shift_type, obj?.reversedate)} key={index} value={elm?.value}>{elm?.label}</option>
                                                                        ))}

                                                                    </select>

                                                                </Grid>
                                                            </Fragment>
                                                        ))}

                                                    </>}
                                                </Fragment>
                                            ))}

                                            <Grid item md={3} xs={6}>
                                                <Button onClick={changestatus} variant='contained' fullWidth color='success'>
                                                    Reconfirm Your Shift Details
                                                </Button>
                                            </Grid>
                                            <Modal open={openModal} onClose={() => {
                                                setreconfirm(false)
                                                setOpenModal(!openModal)
                                            }}>
                                                <div className="col-xl-6 col-lg-8 col-md-10 col-sm-12 col-xs-12 col-12 mt-30 mx-auto ">
                                                    <Card sx={{ borderRadius: 3 }}>
                                                        <CardContent>
                                                            <div style={{ marginBottom: "8px", fontSize: "18px", fontWeight: "bolder", textAlign: "center", color: "black" }}>Re-Confirm Your Shift Details</div>
                                                            <hr />
                                                            <div style={{ paddingBottom: "4px", fontSize: "14px", fontWeight: "bold" }}><span>Job Address : </span><span style={{ color: "#117fb7" }}>{factoryaddress?.address}</span></div>
                                                            <div className='table-responsive'>
                                                                <table className='table table-bordered table-responsive table-striped'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ color: "red" }}>Shift Details</th>
                                                                            <th colSpan={4} style={{ color: "red" }}>Going Availability</th>
                                                                            <th colSpan={4} style={{ color: "red" }}>Return Availability</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Date</th>
                                                                            <th>Mor</th>
                                                                            <th>Aft</th>
                                                                            <th>Eve</th>
                                                                            <th>Ngt</th>
                                                                            <th>Mor</th>
                                                                            <th>Aft</th>
                                                                            <th>Eve</th>
                                                                            <th>Ngt</th>
                                                                        </tr>

                                                                    </thead>
                                                                    <tbody>
                                                                        {shiftdata.map((ele) => (
                                                                            <tr>
                                                                                <td style={{ color: "#117fb7" }}>{sliceDate(ele?.date)}</td>
                                                                                {ele?.data.map((elm) => (
                                                                                    <td>{elm?.going_time}</td>
                                                                                ))}
                                                                                {ele?.data.map((elm) => (
                                                                                    <td>{elm?.return_time}</td>
                                                                                ))}
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div style={{ fontSize: "15px", paddingBottom: "19px", paddingTop: "10px" }}> <DoNotTouch /> For Continue Form Filling Cick On <Forward /> Continue Edit Button</div>

                                                            <button type="button" className='btn btn-primary me-4' onClick={() => {
                                                                setreconfirm(false)
                                                                setOpenModal(false)
                                                            }} style={{ fontSize: "18px" }} >
                                                                Edit
                                                            </button>
                                                            <button className='btn btn-success' onClick={Addshift} style={{ fontSize: "18px" }} >
                                                                {btnloader && <CircularProgress sx={{ color: "white" }} size={30} />} Confirm
                                                            </button>

                                                        </CardContent>
                                                    </Card>
                                                </div>
                                            </Modal>

                                        </Grid>

                                    </Fragment>
                                }

                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </> : <>
                <Termagree isagree={isagree} usertype={"rider"} handlechange={changeagreestate} />
            </>}

        </>}


    </>)
}

export default DriverShiftAvailablity;